import { fade } from '@material-ui/core/styles';
import createPalette from '@material-ui/core/styles/createPalette';

import { blue, blueGrey, gold, green, neutral, red } from './colors';

export const light = createPalette({
  type: 'light',
  common: {
    black: neutral[900],
    white: neutral[50],
  },
  primary: {
    light: gold[300],
    main: gold[300],
    dark: gold[700],
    contrastText: neutral[900],
  },
  secondary: {
    light: blue[300],
    main: blue[500],
    dark: blue[700],
    contrastText: neutral[50],
  },
  error: {
    light: red[300],
    main: red[500],
    dark: red[700],
    contrastText: neutral[50],
  },
  warning: {
    light: gold[300],
    main: gold[500],
    dark: gold[700],
    contrastText: neutral[900],
  },
  info: {
    light: blue[300],
    main: blue[500],
    dark: blue[700],
    contrastText: neutral[50],
  },
  success: {
    light: green[300],
    main: green[500],
    dark: green[700],
    contrastText: neutral[50],
  },
  grey: {
    '50': blueGrey[50],
    '100': blueGrey[100],
    '200': blueGrey[200],
    '300': blueGrey[300],
    '400': blueGrey[400],
    '500': blueGrey[500],
    '600': blueGrey[600],
    '700': blueGrey[700],
    '800': blueGrey[800],
    '900': blueGrey[900],
    A100: blueGrey[100],
    A200: blueGrey[200],
    A400: blueGrey[200],
    A700: blueGrey[700],
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  text: {
    primary: neutral[900],
    secondary: neutral[700],
    disabled: neutral[700],
  },
  divider: fade(neutral[500], 0.5),
  background: {
    paper: neutral[50],
    default: neutral[200],
  },
  action: {
    active: fade(blueGrey[800], 0.5),
    hover: fade(blueGrey[800], 0.04),
    hoverOpacity: 0.04,
    selected: fade(blueGrey[800], 0.08),
    selectedOpacity: 0.08,
    disabled: fade(blueGrey[800], 0.2),
    disabledBackground: fade(blueGrey[800], 0.12),
    disabledOpacity: 0.3,
    focus: fade(blueGrey[800], 0.12),
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  },
});

export const dark = createPalette({
  ...light,
  type: 'dark',
  divider: fade(blueGrey[100], 0.2),
  text: {
    primary: neutral[50],
    secondary: neutral[400],
    disabled: neutral[400],
  },
  background: {
    paper: blueGrey[800],
    default: blueGrey[900],
  },
  action: {
    active: fade(blueGrey[100], 0.5),
    hover: fade(blueGrey[100], 0.04),
    hoverOpacity: 0.04,
    selected: fade(blueGrey[100], 0.08),
    selectedOpacity: 0.08,
    disabled: fade(blueGrey[100], 0.2),
    disabledBackground: fade(blueGrey[100], 0.12),
    disabledOpacity: 0.3,
    focus: fade(blueGrey[100], 0.12),
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  },
});
